import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { CustomTabPanel } from ".";

export const PlannedActivitiesComponent = ({
    value,
    plannedActivities,
    handleChangeTab,
    handleChangeRequirementFilter,
}: {
    value: any;
    plannedActivities: any;
    handleChangeTab: any;
    handleChangeRequirementFilter: any;
}) => {
    const columns: GridColDef[] = [
        { field: "id", headerName: "ID", flex: 1 },
        { field: "planningEndDate", headerName: "Planning Date", flex: 1 },
        { field: "executedBy", headerName: "Ejecutado Por", flex: 1 },
        { field: "groupAssigned", headerName: "Cuadrilla", flex: 1 },
        { field: "tempPlannedAdvance", headerName: "% Temp Planned", flex: 1 },
        { field: "tempFieldAdvance", headerName: "% Temp Field", flex: 1 },
        { field: "advanced", headerName: "% Online", flex: 1 },
        { field: "status", headerName: "Estado", flex: 1 },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onClick = () => {
                    const activityIdFilter = params.row.activityIdFilter;
                    handleChangeRequirementFilter(activityIdFilter);
                    handleChangeTab(undefined, 2);
                };

                return (
                    <Button variant="contained" onClick={onClick} size="small">
                        Ver
                    </Button>
                );
            },
        },
    ];

    const [requires, setRequires] = useState<any[]>([]);

    const paginationModel = { page: 0, pageSize: 10 };

    useEffect(() => {
        const data: any[] = [];

        plannedActivities?.forEach((act: any, index: number) => {
            const activityIdFilter = `${act.planningEndDate} - ${act.groupAssigned}`;

            data.push({
                id: index + 1,
                executedBy: act.executedBy,
                planningEndDate: act.planningEndDate,
                groupAssigned: act.groupAssigned,
                tempPlannedAdvance: `${act.tempPlannedAdvance}% - (${act.executedPlannedActivities} / ${act.plannedActivities})`,
                tempFieldAdvance: `${act.tempFieldAdvance}% - (${act.executedFieldActivities} / ${act.plannedActivities})`,
                advanced: act.advanced,
                status: act.status,
                activityIdFilter,
            });
        });

        setRequires(data);
    }, [plannedActivities]);


    return (<CustomTabPanel value={value} index={1}>
        <Grid size={12}>
            <Paper sx={{ height: '55vh', width: '100%' }}>
                <DataGrid
                    rows={requires}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{ border: 0 }}
                    onRowClick={() => {}}
                />
            </Paper>

        </Grid>
    </CustomTabPanel>)
}
